import { render, staticRenderFns } from "./DoKoDialogRegeln.vue?vue&type=template&id=cb9b7562&scoped=true&"
import script from "./DoKoDialogRegeln.vue?vue&type=script&lang=ts&"
export * from "./DoKoDialogRegeln.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoDialogRegeln.vue?vue&type=style&index=0&id=cb9b7562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9b7562",
  null
  
)

export default component.exports